import { ApolloClient, InMemoryCache } from "@apollo/client"
import config from "../config/config"

const gqlClient = new ApolloClient({
  uri: config["cp-genesis"].url,
  cache: new InMemoryCache()
})
export default gqlClient
